import { Logger } from "./logger";

const console = new Logger('RNBridge', true)

export const RNBridge = {
  context: null,
  send: (type, data) => {
    const message = { type, payload: data }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message))
    } else {
      console.log('React Native Message:', message);
    }
  },
  sendLocalUser: () => {
    const context = RNBridge.context
    if (!context) {
      console.warn('Context is empty')
      return
    }
    try {
      const localUser = context.getLocalUser()
      RNBridge.send('localUser', localUser)
    } catch (e) {
      console.warn('sendLocalUser error', e.message)
    }
  },
  sendConnectionFailed: (message) => {
    try {
      RNBridge.send('connectionFailed', message)
    } catch (e) {
      console.warn('connectionFailed error', e.message)
    } 
  },
  parse: (json) => {
    try {
      const data = typeof json === 'string' ? JSON.parse(json) : json
      return data;
    } catch (e) {
      console.warn('Failed to parse message json', e, json)
    }
  },
  onMessage: async (json) => {
    const message = RNBridge.parse(json)
    console.warn('message', message)
    if (!message) {
      return;
    }
    const context = RNBridge.context;
    if (!context) {
      console.warn('Context is empty')
      return;
    }
    let audioState;
    let videoState;
    try {
      switch (message.type) {
        case 'switchCamera':
          await context.switchCamera();
          RNBridge.send('switchCamera')
          break;
        case 'toggleAudio':
          audioState = await context.toggleAudio()
          RNBridge.send('toggleAudio', audioState)
          break;
        case 'toggleVideo':
          videoState = await context.toggleVideo()
          RNBridge.send('toggleVideo', videoState)
          break;
        case 'localUser':
          RNBridge.sendLocalUser()
          break;
        case 'leaveSession':
          await context.leaveSession()
          RNBridge.send('leaveSession')
          break;
        case 'signal':
          context.sendSignal(message.payload)
          break;
        default:
          console.warn('Unknown message', message)
      }
    } catch (e) {
      console.error('Failed to handle message', e.message, message, e.stack)
    }
  }
}

window.addEventListener('message', (e) => RNBridge.onMessage(e.data))
